{
  "generatedAt": "2026-07-03",
  "source": "src/data/liveDrop.generated.json",
  "policy": "Every live-drop SKU receives one internal launch-prep stock slot, but public stock remains not_stocked_prelaunch and checkout remains disabled.",
  "count": 26,
  "products": [
    {
      "sku": "PPB-SET-0001",
      "image": "/images/products/ppb-set-0001.svg",
      "imageAlt": "Voorbereidende productvisual voor Startset 2 spelers indoor budget; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Startset 2 spelers indoor budget: een logisch startpunt voor beginners thuis/sporthal.",
      "intro": "Snel starten met een complete set die logisch bij elkaar past. Past bij beginners thuis/sporthal. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en thuis, schoolintro, clinic of recreatie.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang update over deze set",
      "secondaryCta": "Start set-keuzehulp"
    },
    {
      "sku": "PPB-SET-0002",
      "image": "/images/products/ppb-set-0002.svg",
      "imageAlt": "Voorbereidende productvisual voor Startset 2 spelers outdoor budget; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Startset 2 spelers outdoor budget: een logisch startpunt voor beginners buiten.",
      "intro": "Snel starten met een complete set die logisch bij elkaar past. Past bij beginners buiten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en thuis, schoolintro, clinic of recreatie.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang update over deze set",
      "secondaryCta": "Start set-keuzehulp"
    },
    {
      "sku": "PPB-SET-0003",
      "image": "/images/products/ppb-set-0003.svg",
      "imageAlt": "Voorbereidende productvisual voor Startset 4 spelers indoor school; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Startset 4 spelers indoor school: een logisch startpunt voor scholen en sporthallen.",
      "intro": "Snel starten met een complete set die logisch bij elkaar past. Past bij scholen en sporthallen. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en thuis, schoolintro, clinic of recreatie.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang update over deze set",
      "secondaryCta": "Start set-keuzehulp"
    },
    {
      "sku": "PPB-SET-0004",
      "image": "/images/products/ppb-set-0004.svg",
      "imageAlt": "Voorbereidende productvisual voor Startset 4 spelers outdoor recreatie; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Startset 4 spelers outdoor recreatie: een logisch startpunt voor gezinnen en recreatieparken.",
      "intro": "Snel starten met een complete set die logisch bij elkaar past. Past bij gezinnen en recreatieparken. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en thuis, schoolintro, clinic of recreatie.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang update over deze set",
      "secondaryCta": "Start set-keuzehulp"
    },
    {
      "sku": "PPB-SET-0013",
      "image": "/images/products/ppb-set-0013.svg",
      "imageAlt": "Voorbereidende productvisual voor Blue Lightning Pack 2 paddle set; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Blue Lightning Pack 2 paddle set: een logisch startpunt voor beginners met merkvoorkeur.",
      "intro": "Snel starten met een complete set die logisch bij elkaar past. Past bij beginners met merkvoorkeur. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en thuis, schoolintro, clinic of recreatie.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor JOOLA vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang update over deze set",
      "secondaryCta": "Start set-keuzehulp"
    },
    {
      "sku": "PPB-SET-0017",
      "image": "/images/products/ppb-set-0017.svg",
      "imageAlt": "Voorbereidende productvisual voor Flash Pack 2 paddle starter; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Flash Pack 2 paddle starter: een logisch startpunt voor beginners.",
      "intro": "Snel starten met een complete set die logisch bij elkaar past. Past bij beginners. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en thuis, schoolintro, clinic of recreatie.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor HEAD vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang update over deze set",
      "secondaryCta": "Start set-keuzehulp"
    },
    {
      "sku": "PPB-PAD-0026",
      "image": "/images/products/ppb-pad-0026.svg",
      "imageAlt": "Voorbereidende productvisual voor Essentials 14mm control; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Essentials 14mm control: een logisch startpunt voor recreanten/intermediate.",
      "intro": "Meer controle over grip, gewicht en speelgevoel. Past bij recreanten/intermediate. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij intermediate-niveau en spelers die gerichter willen kiezen dan een basisset.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor JOOLA vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang paddle-update",
      "secondaryCta": "Start paddle-keuzehulp"
    },
    {
      "sku": "PPB-PAD-0029",
      "image": "/images/products/ppb-pad-0029.svg",
      "imageAlt": "Voorbereidende productvisual voor Agassi Champion 14mm control; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Agassi Champion 14mm control: een logisch startpunt voor recreanten/intermediate.",
      "intro": "Meer controle over grip, gewicht en speelgevoel. Past bij recreanten/intermediate. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij intermediate-niveau en spelers die gerichter willen kiezen dan een basisset.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor JOOLA vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang paddle-update",
      "secondaryCta": "Start paddle-keuzehulp"
    },
    {
      "sku": "PPB-PAD-0059",
      "image": "/images/products/ppb-pad-0059.svg",
      "imageAlt": "Voorbereidende productvisual voor Flash standard; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Flash standard: een logisch startpunt voor beginners/recreanten.",
      "intro": "Meer controle over grip, gewicht en speelgevoel. Past bij beginners/recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en spelers die gerichter willen kiezen dan een basisset.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor HEAD vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang paddle-update",
      "secondaryCta": "Start paddle-keuzehulp"
    },
    {
      "sku": "PPB-PAD-0061",
      "image": "/images/products/ppb-pad-0061.svg",
      "imageAlt": "Voorbereidende productvisual voor Attitude CORE standard; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Attitude CORE standard: een logisch startpunt voor beginners/recreanten.",
      "intro": "Meer controle over grip, gewicht en speelgevoel. Past bij beginners/recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij starter-niveau en spelers die gerichter willen kiezen dan een basisset.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor HEAD vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang paddle-update",
      "secondaryCta": "Start paddle-keuzehulp"
    },
    {
      "sku": "PPB-BAL-0142",
      "image": "/images/products/ppb-bal-0142.svg",
      "imageAlt": "Voorbereidende productvisual voor X-40 Outdoor 3-pack; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "X-40 Outdoor 3-pack: een logisch startpunt voor beginners.",
      "intro": "Het juiste baltype voorkomt slecht stuitgedrag en miskopen. Past bij beginners. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en training, recreatie, indoor of outdoor spel.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor Franklin Sports vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang ballen-update",
      "secondaryCta": "Kies indoor of outdoor"
    },
    {
      "sku": "PPB-BAL-0143",
      "image": "/images/products/ppb-bal-0143.svg",
      "imageAlt": "Voorbereidende productvisual voor X-40 Outdoor 12-pack; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "X-40 Outdoor 12-pack: een logisch startpunt voor recreanten/clubs.",
      "intro": "Het juiste baltype voorkomt slecht stuitgedrag en miskopen. Past bij recreanten/clubs. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij club-niveau en training, recreatie, indoor of outdoor spel.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor Franklin Sports vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang ballen-update",
      "secondaryCta": "Kies indoor of outdoor"
    },
    {
      "sku": "PPB-BAL-0145",
      "image": "/images/products/ppb-bal-0145.svg",
      "imageAlt": "Voorbereidende productvisual voor X-26 Indoor 3-pack; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "X-26 Indoor 3-pack: een logisch startpunt voor beginners.",
      "intro": "Het juiste baltype voorkomt slecht stuitgedrag en miskopen. Past bij beginners. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en training, recreatie, indoor of outdoor spel.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor Franklin Sports vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang ballen-update",
      "secondaryCta": "Kies indoor of outdoor"
    },
    {
      "sku": "PPB-BAL-0148",
      "image": "/images/products/ppb-bal-0148.svg",
      "imageAlt": "Voorbereidende productvisual voor Primo 3-pack; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Primo 3-pack: een logisch startpunt voor recreanten.",
      "intro": "Het juiste baltype voorkomt slecht stuitgedrag en miskopen. Past bij recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en training, recreatie, indoor of outdoor spel.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor JOOLA vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang ballen-update",
      "secondaryCta": "Kies indoor of outdoor"
    },
    {
      "sku": "PPB-BAL-0150",
      "image": "/images/products/ppb-bal-0150.svg",
      "imageAlt": "Voorbereidende productvisual voor HC-40 3-pack; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "HC-40 3-pack: een logisch startpunt voor recreanten.",
      "intro": "Het juiste baltype voorkomt slecht stuitgedrag en miskopen. Past bij recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en training, recreatie, indoor of outdoor spel.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor JOOLA vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang ballen-update",
      "secondaryCta": "Kies indoor of outdoor"
    },
    {
      "sku": "PPB-BAL-0154",
      "image": "/images/products/ppb-bal-0154.svg",
      "imageAlt": "Voorbereidende productvisual voor Pro 40 Outdoor 3-pack; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Pro 40 Outdoor 3-pack: een logisch startpunt voor beginners/recreanten.",
      "intro": "Het juiste baltype voorkomt slecht stuitgedrag en miskopen. Past bij beginners/recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en training, recreatie, indoor of outdoor spel.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor HEAD/Penn vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang ballen-update",
      "secondaryCta": "Kies indoor of outdoor"
    },
    {
      "sku": "PPB-NET-0172",
      "image": "/images/products/ppb-net-0172.svg",
      "imageAlt": "Voorbereidende productvisual voor Portable Net standard; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Portable Net standard: een logisch startpunt voor thuis/scholen/clubs.",
      "intro": "Een tijdelijke baan professioneel en veilig opzetten. Past bij thuis/scholen/clubs. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij club-niveau en clubs, scholen, opritten en tijdelijke velden.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Vraag net- en veldadvies",
      "secondaryCta": "Bespreek pakket"
    },
    {
      "sku": "PPB-NET-0181",
      "image": "/images/products/ppb-net-0181.svg",
      "imageAlt": "Voorbereidende productvisual voor Court Line Kit standard; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Court Line Kit standard: een logisch startpunt voor thuis/scholen/clubs.",
      "intro": "Een tijdelijke baan professioneel en veilig opzetten. Past bij thuis/scholen/clubs. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij club-niveau en clubs, scholen, opritten en tijdelijke velden.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Vraag net- en veldadvies",
      "secondaryCta": "Bespreek pakket"
    },
    {
      "sku": "PPB-NET-0187",
      "image": "/images/products/ppb-net-0187.svg",
      "imageAlt": "Voorbereidende productvisual voor Court Marker Set standard; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Court Marker Set standard: een logisch startpunt voor thuis/scholen/clubs.",
      "intro": "Een tijdelijke baan professioneel en veilig opzetten. Past bij thuis/scholen/clubs. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij club-niveau en clubs, scholen, opritten en tijdelijke velden.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Vraag net- en veldadvies",
      "secondaryCta": "Bespreek pakket"
    },
    {
      "sku": "PPB-ACC-0197",
      "image": "/images/products/ppb-acc-0197.svg",
      "imageAlt": "Voorbereidende productvisual voor Overgrip 3-pack; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Overgrip 3-pack: een logisch startpunt voor clubs/recreanten.",
      "intro": "Kleine add-ons die grip, comfort en onderhoud verbeteren. Past bij clubs/recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij club-niveau en spelers die hun paddle langer prettig willen gebruiken.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang accessoire-update",
      "secondaryCta": "Bekijk add-ons"
    },
    {
      "sku": "PPB-ACC-0202",
      "image": "/images/products/ppb-acc-0202.svg",
      "imageAlt": "Voorbereidende productvisual voor Paddle Eraser single; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Paddle Eraser single: een logisch startpunt voor recreanten.",
      "intro": "Kleine add-ons die grip, comfort en onderhoud verbeteren. Past bij recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en spelers die hun paddle langer prettig willen gebruiken.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang accessoire-update",
      "secondaryCta": "Bekijk add-ons"
    },
    {
      "sku": "PPB-ACC-0206",
      "image": "/images/products/ppb-acc-0206.svg",
      "imageAlt": "Voorbereidende productvisual voor Edge Guard Tape single; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Edge Guard Tape single: een logisch startpunt voor recreanten.",
      "intro": "Kleine add-ons die grip, comfort en onderhoud verbeteren. Past bij recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en spelers die hun paddle langer prettig willen gebruiken.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang accessoire-update",
      "secondaryCta": "Bekijk add-ons"
    },
    {
      "sku": "PPB-BAG-0220",
      "image": "/images/products/ppb-bag-0220.svg",
      "imageAlt": "Voorbereidende productvisual voor Paddle Sling Bag standard; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Paddle Sling Bag standard: een logisch startpunt voor recreanten.",
      "intro": "Materiaal overzichtelijk meenemen naar baan, les of clubavond. Past bij recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en recreanten en spelers met meerdere paddles of ballen.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang tas-update",
      "secondaryCta": "Bekijk bundelroute"
    },
    {
      "sku": "PPB-BAG-0224",
      "image": "/images/products/ppb-bag-0224.svg",
      "imageAlt": "Voorbereidende productvisual voor Backpack standard; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Backpack standard: een logisch startpunt voor recreanten.",
      "intro": "Materiaal overzichtelijk meenemen naar baan, les of clubavond. Past bij recreanten. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en recreanten en spelers met meerdere paddles of ballen.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang tas-update",
      "secondaryCta": "Bekijk bundelroute"
    },
    {
      "sku": "PPB-SHO-0258",
      "image": "/images/products/ppb-sho-0258.svg",
      "imageAlt": "Voorbereidende productvisual voor Owl Eyewear clear lens; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Owl Eyewear clear lens: een logisch startpunt voor jeugd/beginners/dubbelspel.",
      "intro": "Extra bescherming met duidelijke uitleg over gebruik en pasvorm. Past bij jeugd/beginners/dubbelspel. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij recreatief-niveau en jeugd, dubbelspel en spelers die veilig willen starten.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Voor ONIX vullen we definitieve foto's, specificaties en verkoopinformatie aan zodra verkoop opent."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Ontvang beschikbaarheidsupdate",
      "secondaryCta": "Bekijk veiligheidsadvies"
    },
    {
      "sku": "PPB-CLB-0284",
      "image": "/images/products/ppb-clb-0284.svg",
      "imageAlt": "Voorbereidende productvisual voor Clubpack 8 spelers indoor; definitieve productfoto volgt.",
      "imageDisclosure": "Voorbereidende visual; definitieve productfoto volgt zodra verkoopinformatie bevestigd is.",
      "launchPrepStockQty": 1,
      "launchPrepStockStatus": "internal_launch_prep_not_public_stock",
      "checkoutFlowStatus": "blocked_until_checkout_ready",
      "headline": "Clubpack 8 spelers indoor: een logisch startpunt voor scholen en sportclubs.",
      "intro": "Een pakket samenstellen rond spelersaantal, veldtype en lesvorm. Past bij scholen en sportclubs. Laat je e-mailadres achter en ontvang een bericht zodra prijs, levering en bestellen definitief zijn.",
      "bullets": [
        "Past bij club-niveau en scholen, clubs, clinics en sportorganisaties.",
        "Helpt je kiezen zonder losse producten en specificaties door elkaar te halen.",
        "Deze selectie staat klaar voor beschikbaarheidsupdates en advies; definitieve verkoop volgt zodra beschikbaarheid en productinformatie rond zijn."
      ],
      "objections": [
        "Dit product is nog niet direct te bestellen; je kunt wel alvast een update ontvangen.",
        "Definitieve levertijd, prijs en productspecificaties worden pas getoond wanneer ze bevestigd zijn.",
        "De afbeelding is een voorbereidende visual; de definitieve productfoto volgt bij verkoop."
      ],
      "primaryCta": "Vraag pakketadvies aan",
      "secondaryCta": "Bespreek je clubpakket"
    }
  ]
}
